import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectTemplateSelectionParams, setTemplateSelectionParams, TemplateSelectionParams } from '../../../store/templateLibrary/templateSelectionSlice'
import { useNavigate } from 'react-router-dom'
import { TemplateTabContent } from '../../../models/TemplateLibrary'
import { useMemo } from 'react'
import { calculateHierarchyId } from './utils'

export const useTemplateSelection = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const templateSelectionParams = useAppSelector(selectTemplateSelectionParams)
  const selectTemplate = (props: TemplateSelectionParams) => {
    dispatch(setTemplateSelectionParams(props))
    navigate('/workspace/setup/templates/templates')
  }

  const templateTabContent: TemplateTabContent | null = templateSelectionParams
    ? {
        key: templateSelectionParams.header,
        label: 'templates',
        header: templateSelectionParams.header,
        subHeader: templateSelectionParams.subHeader,
        searchParams: {
          type: templateSelectionParams.type,
          typeId: templateSelectionParams.typeId,
          defaultTypeId: templateSelectionParams.context.defaultTypeId,
          createdBy: templateSelectionParams.context.userId,
          scopes: templateSelectionParams.context.userId ? undefined : ['system', 'account'],
        },
        showTemplateType: true,
      }
    : null

  const calculatedHierarchyId = useMemo(() => {
    return templateSelectionParams ? calculateHierarchyId(templateSelectionParams.type, templateSelectionParams.context) : null
  }, [templateSelectionParams])

  return { selectTemplate, templateTabContent, templateSelectionParams, hierarchyId: calculatedHierarchyId }
}
